// extracted by mini-css-extract-plugin
module.exports = {"news_sider":"news_sider-27rktrh3","sider_box":"sider_box-zNIn8d7U","box":"box-3J7SXsmZ","newsSiderAd":"newsSiderAd-2MgkC-jG"};